"use strict";var o=require("styled-components"),e=require("./rangeThumbnail.svg.js");function t(o){return o&&"object"==typeof o&&"default"in o?o:{default:o}}var r=t(o).default.section`
    position: relative;

    .hint {
        margin: 0;
        text-transform: uppercase;
        position: absolute;
        bottom: 100%;
        left: 50%;
        color: ${({theme:o})=>o.colors.common.light};
        padding: 7px 14px;
        transform: translate3D(-50%, -25px, 0);
        transition: all 0.4s ease-in-out;
        text-align: center;
        width: max-content;

        &.hidden {
            opacity: 0;
        }

        &::after {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: ${({theme:o})=>o.colors.common.dark};
            opacity: 0.8;
            border-radius: 15px;
            z-index: -1;
        }
    }

    input {
        cursor: pointer;
        width: 100%;
        box-sizing: border-box;
        -webkit-appearance: none;
        height: 5px;
        background: ${({theme:o})=>o.colors.common.light};
        border: solid 1px ${({theme:o})=>o.colors.grey[600]};
        border-radius: 3px;

        &::-moz-range-thumb {
            width: ${52}px;
            height: ${52}px;
            background: url(${e});
            background-repeat: no-repeat;
            background-color: ${({theme:o})=>o.colors.common.light};
            background-position: center;
            border-radius: 100%;
            border: solid 1px ${({theme:o})=>o.colors.grey[600]};
            box-shadow: ${({theme:o})=>o.shadows.high};
            opacity: 1;
        }

        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            width: ${52}px;
            height: ${52}px;
            background: url(${e});
            background-repeat: no-repeat;
            background-color: ${({theme:o})=>o.colors.common.light};
            background-position: center;
            border-radius: 100%;
            border: solid 1px ${({theme:o})=>o.colors.grey[600]};
            box-shadow: ${({theme:o})=>o.shadows.high};
            opacity: 1;
        }
    }
`;module.exports=r;
//# sourceMappingURL=styles.js.map
